import { useCallback } from 'react';

/**
 * Hook to trigger haptic feedback on supported devices.
 */
export function useHaptics() {
    const triggerHaptic = useCallback((pattern: number | number[] = 10) => {
        // Check for support
        if (typeof navigator !== 'undefined' && navigator.vibrate) {
            try {
                navigator.vibrate(pattern);
            } catch {
                // Ignore errors (some browsers restrict vibration)
            }
        }
    }, []);

    return { triggerHaptic };
}
